import type { TypographyProps } from '@mui/material';
import { CircularProgress, Stack, Typography } from '@mui/material';

type LoaderProps = {
  size?: 'small' | 'medium' | 'large';
  variant?: TypographyProps['variant'];
};
export const Loader = (props: LoaderProps) => {
  const { size = 'medium', variant = 'h5' } = props;
  const sizeMap = {
    small: 20,
    medium: 30,
    large: 40,
  };
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap={4}
      width="100%"
      height="100%"
    >
      <CircularProgress size={sizeMap[size]} />
      <Typography variant={variant}>Загрузка...</Typography>
    </Stack>
  );
};
